import handleNotify from "../utils/helpers/handleNotify.js";
import { apiFetchTinkoffPaymentUrl } from "../api/methods/payment.js";

export default function usePayment() {
  /**
   * Получить ссылку на страницу с формой оплаты Тинькофф Банка
   *
   * @param {Number} contractId
   * @param {String} billingId
   * @param {Number} sumPayment
   * @param {String} source
   * @param {?String} tag
   */
  const getPaymentTinkoffUrl = async (contractId, billingId, sumPayment, source = "", tag = "") => {
    try {
      const response = await apiFetchTinkoffPaymentUrl(
        contractId,
        billingId,
        sumPayment,
        source,
        tag
      );

      window.location.href = response.data.payment_url;
    } catch (error) {
      handleNotify("error", error);
    }
  };

  /**
   * Функция для отображения уведомлений после оплаты для Уфанета
   */
  const handlePaymentDefault = () => {
    /**
     * При оплате через Тинькофф-Банк в url добавляются get-параметры.
     *
     * Параметр source позволяет управлять отображением уведомлениями NotifyMessage
     * там где это необходимо.
     *
     * Для отображения нужного типа уведомления используется ключ isPaid
     */
    const urlParams = new URLSearchParams(window.location.search);
    const isPaidSuccess = urlParams.get("isPaid") === "true";

    if (isPaidSuccess) {
      handleNotify(
        "success",
        "Платеж обрабатывается банком",
        "Ожидайте поступления денег на счет. Обычно это происходит в течение 10 минут"
      );

      return { isPaidSuccess: true };
    } else {
      handleNotify(
        "error",
        "Ошибка при оплате",
        "Возможно данные карты были указаны неверно или не хватило денег. Попробуйте еще раз"
      );

      return { isPaidSuccess: false };
    }
  };

  return {
    getPaymentTinkoffUrl,
    handlePaymentDefault,
  };
}
